export default {
  path: '/mobile',
  meta: {
    title: '',
  },
  component: r => require.ensure([], () => r(require(`./index.vue`)), `/mobile`),
}



// WEBPACK FOOTER //
// ./src/views/changMobile/router.js